export function EnvironmentBanner() {
  // Only show in non-production environments
  const isStaging = window.location.hostname.includes('git-staging') || 
                    window.location.hostname.includes('staging') ||
                    window.location.hostname === 'localhost';

  if (!isStaging) return null;

  const envName = window.location.hostname === 'localhost' ? 'LOCAL' : 'STAGING';
  const bgColor = envName === 'LOCAL' ? 'bg-purple-600' : 'bg-orange-600';

  return (
    <div className={`fixed top-0 left-0 right-0 z-[9999] ${bgColor} text-white text-center py-1 text-sm font-semibold shadow-lg`}>
      🚧 {envName} ENVIRONMENT - Not Production 🚧
    </div>
  );
}
